<template>
  <div class="c-content-two-column" :class="{ padding: fields?.padding?.value === true }">
    <div class="column">
      <sc-placeholder name="jss-content-two-column-left" :rendering="rendering" />
    </div>
    <div class="column">
      <sc-placeholder name="jss-content-two-column-right" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Content-Two-Column',
  components: {
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.c-content-two-column {
  @include margin-y(2rem);
  @include padding-x-thin;

  @include desktop-up {
    display: flex;
    flex-direction: row;
    @include margin-y(2rem, 4rem);
  }

  &.padding {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .column {
    margin-bottom: 4rem;

    @include desktop-up {
      width: 50%;
      margin-bottom: 0;
    }

    &:first-child {
      @include desktop-up {
        padding-right: 2.5rem;
      }
    }

    &:last-child {
      @include desktop-up {
        padding-left: 2.5rem;
      }
    }

    &:deep() {
      h3 {
        font-size: 2rem;
        line-height: 2.6rem;

        @include desktop-up {
          font-size: 2.8rem;
          line-height: 3.5rem;
        }
      }

      p {
        font-size: 1.6rem;
        line-height: 2rem;
        margin-bottom: 2rem;

        @include desktop-up {
          font-size: 2rem;
          line-height: 2.6rem;
          margin-bottom: 3rem;
        }
      }

      .c-cta--secondary {
        margin-bottom: 0;
      }
    }
  }
}
</style>
